// 简体中文
export default {
    /* 登录、注册 =======================================================0 */
    "登录": "Đăng nhập",
    "注册": "Đăng ký",
    "忘记密码": "Quên mật khẩu?",
    "没有账号？马上注册": "Chưa có tài khoản? Đăng ký ngay",
    "请输入手机号": "Vui lòng nhập tên tài khoản",
    "请输入密码": "Vui lòng nhập mật khẩu",
    "请确认密码": "Vui lòng xác nhận mật khẩu",
    "请输入邀请码": "Vui lòng nhập mã giới thiệu",
    "密码确认失败，请重新设置": "Xác nhận mật khẩu thất bại, vui lòng thiết lập lại",
    "登录中...": "Đang đăng nhập...",
    "登录成功": "Đăng nhập thành công",
    "注册中...": "Đang đăng ký...",
    "注册成功,即将跳转首页": "Đăng ký thành công, đang chuyển đến trang chủ",
    "我已经知晓并同意开户协议各项条约": "Tôi đã hiểu và đồng ý với các điều khoản của Thỏa thuận mở tài khoản",
    "请阅读并同意开户协议": "Vui lòng đọc và đồng ý với Thỏa thuận mở tài khoản",
    "已有账号？马上登录": "Đã có tài khoản? Đăng nhập ngay",
    "请联系在线客服": "Vui lòng liên hệ chăm sóc khách hàng trực tuyến",
    /* 登录、注册 =======================================================1 */

    /* 首页 ============================================================0 */
    "首页": "Trang chủ",
    "请选择地区": "Vui lòng chọn khu vực",
    "全国第一福利品": "Sản phẩm phúc lợi số 1 toàn quốc",
    "为了会员权益，网站只展示 1% 资源并且不定期更新只为展示实力，如需查询预约更多资源请联系上级接待": "Vì quyền lợi của hội viên, trang web chỉ hiển thị 1% tài nguyên và cập nhật định kỳ để chứng minh năng lực. Nếu cần tra cứu và đặt lịch thêm tài nguyên, vui lòng liên hệ lễ tân cấp trên",
    "本平台所有资源真实、安全、可靠，全国空降、同城约炮选取你心仪的她，与您零距离邂逅，快加入我们吧": "Tất cả tài nguyên trên nền tảng này đều chân thực, an toàn, tin cậy. Hẹn hò cùng thành phố, giao tận nơi toàn quốc, chọn người bạn thích và gặp gỡ khoảng cách bằng 0. Hãy tham gia ngay!",
    "平台资源": "Tài nguyên nền tảng",
    "昵称": "Biệt danh:",
    "类型": "Loại:",
    "距离：点击查看": "Khoảng cách: Nhấp để xem",
    "服务项目：激活可见": "Hạng mục dịch vụ: Kích hoạt để xem",
    "已认证": "Đã xác thực",
    "查看更多": "Xem thêm",
    "当前地区暂无资源": "Khu vực hiện tại tạm thời chưa có tài nguyên",
    "服务条款": "Điều khoản dịch vụ",
    "网红、模特、空姐、嫩模、大学生、留学生，只有您想不到，没有本平台办不到": "Hotgirl, người mẫu, tiếp viên hàng không, người mẫu trẻ, sinh viên, du học sinh, chỉ cần bạn nghĩ tới, nền tảng đều có thể đáp ứng.",
    "服务范围": "Phạm vi dịch vụ",
    "同城约炮，任意地点空降，国内一二线城市当地均有，三线城市也可以通过上级预约安排": "Hẹn hò cùng thành phố, giao tận nơi mọi địa điểm. Có mặt tại các thành phố lớn tuyến 1, 2 và các thành phố tuyến 3 có thể sắp xếp qua đặt lịch cấp trên.",
    "热门地区": "Khu vực nổi bật",
    "更多地区": "Thêm khu vực",
    "网红、模特、空姐、嫩模、大学生、留学生": ['Hotgirl', 'Người mẫu', 'Tiếp viên hàng không', 'Người mẫu trẻ', 'Sinh viên', 'Du học sinh'],
    "请联系管理员激活账号": "Vui lòng liên hệ với quản trị viên để kích hoạt tài khoản của bạn.",
    "请联系客服获取更多信息": "Vui lòng liên hệ CSKH để biết thêm thông tin",
    /* 首页 ============================================================1 */

    /* 福利 ============================================================0 */
    "福利": "sản phẩm",
    "全部": "Tất cả",
    /* 福利 ============================================================1 */

    /* 视频 ============================================================0 */
    "视频": "Video",
    /* 视频 ============================================================1 */

    /* 我的 ============================================================0 */
    "我的": "Của tôi",
    "余额": "Số dư",
    "元": "VND",
    "¥": "₫",
    "CNY": "VND",
    "我的信用分": "Điểm tín dụng của tôi",
    "我的客服": "CSKH của tôi",
    "提现": "Rút tiền",
    "提现记录": "Lịch sử rút tiền",
    "个人报表": "Báo cáo cá nhân",
    "任务记录": "Lịch sử giao dịch",
    "我的消息": "Tin nhắn của tôi",
    "银行卡": "Thẻ ngân hàng",
    "设置": "Cài đặt",
    "未配置跳转链接": "Chưa cấu hình liên kết chuyển hướng",
    "功能尚未开放": "Tính năng chưa mở",
    /* 我的 ============================================================1 */

    /* 美女 ============================================================0 */
    "公告": "Thông báo",
    "基本信息": "Thông tin cơ bản",
    "生日": "Sinh nhật: Ngày ** tháng ** năm ****",
    "身高": "Chiều cao: ***cm",
    "体重": "Cân nặng: ***kg",
    "胸围": "Vòng 1: ***",
    "所在位置：已隐藏，联系客服激活可见": "Vị trí: Đã ẩn, liên hệ CSKH kích hoạt để xem.",
    "联系方式：已隐藏，联系客服激活可见": "Thông tin liên hệ: Đã ẩn, liên hệ CSKH kích hoạt để xem.",
    "服务项目：激活可见": "Hạng mục dịch vụ: Kích hoạt để xem.",
    "祝愿各位会员每天都能遇到美好的恋情，享受快乐的夜晚": "Chúc các hội viên mỗi ngày đều gặp được tình yêu đẹp và tận hưởng đêm hạnh phúc!",
    "立即约她": "Hẹn cô ấy ngay",
    "联系专属客服接待": "Hãy liên hệ với đại diện dịch vụ khách hàng chuyên trách của bạn.",
    /* 美女 ============================================================1 */

    /* 个人报表 ========================================================0 */
    "盈利金额": "Số tiền lợi nhuận",
    "盈利计算公式": "Công thức tính lợi nhuận",
    "任务金额": "Số tiền nhiệm vụ",
    "充值金额": "Số tiền nạp",
    "提现金额": "Số tiền rút",
    "中奖金额": "Số tiền trúng thưởng",
    /* 个人报表 ========================================================1 */

    /* 播放器 ==========================================================0 */
    "播放器": "Trình phát",
    "热门推荐": "Gợi ý nổi bật",
    "提示": "Gợi ý",
    "播放次数已用完，请联系专属客服": "Số lượt phát đã hết, vui lòng liên hệ CSKH riêng",
    /* 播放器 ==========================================================1 */

    /* 下注 ===========================================================0 */
    "彩票": "Xổ số",
    "查看历史开奖": "Xem lịch sử mở thưởng",
    "开奖期数": "Kỳ mở thưởng",
    "中奖号码": "Số trúng thưởng",
    "下单": "Đặt đơn",
    "下注号码": "Số đặt cược",
    "请选择下注号码": "Vui lòng chọn số đặt cược",
    "每注金额": "Số tiền mỗi cược",
    "请输入金额": "Vui lòng nhập số tiền",
    "总计": "Tổng cộng",
    "订单": "Đơn hàng",
    "清空": "Xóa rỗng",
    "余额不足，请联系客服充值": "Số dư không đủ, vui lòng liên hệ CSKH để nạp tiền",
    "付款功能未开通，请联系在线客服": "Tính năng thanh toán chưa mở, vui lòng liên hệ CSKH trực tuyến",
    "付款中...": "Đang thanh toán...",
    "付款成功": "Thanh toán thành công",
    /* 下注 ===========================================================1 */

    /* 任务记录 =======================================================0 */
    "暂无记录": "Chưa có lịch sử",
    "待开奖": "Chờ mở thưởng",
    "订单金额": "Số tiền đơn hàng:",
    "中奖金额": "Số tiền trúng thưởng:",
    "下注时间": "Thời gian đặt cược:",
    "开奖时间": "Thời gian mở thưởng:",
    "隐藏详情": "Ẩn chi tiết",
    "查看详情": "Xem chi tiết",
    "投注号码": "Số đặt cược:",
    "投注金额": "Số tiền đặt cược:",
    /* 任务记录 =======================================================1 */

    /* 银行卡 =========================================================0 */
    "银行名称": "Tên ngân hàng",
    "银行卡号": "Số thẻ ngân hàng",
    "持卡人姓名": "Họ tên chủ thẻ",
    "手机号": "Số điện thoại",
    "点击选择银行": "Nhấp để chọn ngân hàng",
    "请填写银行卡号": "Vui lòng điền số thẻ ngân hàng",
    "请填写持卡人姓名": "Vui lòng điền họ tên chủ thẻ",
    "请填写预留手机号": "Vui lòng điền số điện thoại đăng ký",
    "添加银行卡": "Thêm thẻ ngân hàng",
    "绑定银行卡": "Liên kết thẻ ngân hàng",
    "提示:请绑定大型商业银行, 如需修改, 请您联系在线客服": "Gợi ý: Vui lòng liên kết ngân hàng thương mại lớn, nếu cần sửa đổi vui lòng liên hệ CSKH trực tuyến.",
    "尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款": "Kính gửi quý khách, để đảm bảo an toàn tài sản, vui lòng liên kết họ tên thật và cài đặt mật khẩu rút tiền. Nếu họ tên không trùng với tên mở tài khoản sẽ không thể rút tiền.",
    "请绑定大型商业银行, 如需修改, 请您联系在线客服": "Vui lòng liên kết ngân hàng thương mại lớn, nếu cần sửa đổi vui lòng liên hệ CSKH trực tuyến.",
    /* 银行卡 =========================================================1 */

    /* 提现 ===========================================================0 */
    "记录": "Lịch sử rút tiền",
    "限额说明": "Hướng dẫn hạn mức",
    "单笔交易最低限额": "Hạn mức tối thiểu mỗi giao dịch",
    "单笔交易最高限额": "Hạn mức tối đa mỗi giao dịch",
    "每天可提款次数": "Số lần rút tiền mỗi ngày",
    "到账时间": "Thời gian nhận tiền: Thường khoảng 5 phút, nhanh nhất có thể đạt 2 phút.",
    "请输入资金密码": "Vui lòng nhập mật khẩu rút tiền",
    "请联系专属客服": "Vui lòng liên hệ CSKH riêng",
    "取消": "Hủy",
    "提交中...": "Đang gửi...",
    "说明": "Mô tả",
    "提交时间": "Thời gian gửi",
    "审核时间": "Thời gian duyệt",
    "审核中": "Đang duyệt",
    "请设置提现密码以及绑定银行卡，否则无法使用提现功能": "Vui lòng đặt mật khẩu rút tiền và liên kết thẻ ngân hàng, nếu không thì không thể sử dụng chức năng rút tiền",
    "设置提现密码": "Đặt mật khẩu rút tiền",
    "返回": "trở lại",
    "请绑定银行卡，否则无法使用提现功能": "Vui lòng ràng buộc thẻ ngân hàng của bạn, nếu không bạn không thể sử dụng chức năng rút tiền mặt",
    "绑定银行卡": "Liên kết thẻ ngân hàng",
    /* 提现 ===========================================================1 */

    /* 设置 ===========================================================0 */
    "头像": "Ảnh đại diện",
    "点击选择头像": "Nhấp để chọn ảnh đại diện",
    "姓名": "Họ và tên",
    "点击设置姓名": "Nhấp để đặt họ tên",
    "性别": "Giới tính",
    "男": "Nam",
    "女": "Nữ",
    "未知": "Chưa xác định",
    "点击选择性别": "Nhấp để chọn giới tính",
    "登录密码": "Mật khẩu đăng nhập",
    "去修改": "Đến sửa",
    "资金密码": "Mật khẩu rút tiền",
    "如需修改，请联系专属客服": "Nếu cần sửa đổi, vui lòng liên hệ CSKH riêng",
    "设置动词": "Cài đặt",
    "语言": "Ngôn ngữ",
    "切换语言": "Đổi ngôn ngữ",
    "退出登录": "Đăng xuất",
    "选择头像": "Chọn ảnh đại diện",
    "确定": "Xác nhận",
    "设置姓名": "Đặt họ tên",
    "请输入您的姓名": "Vui lòng nhập họ tên của bạn",
    "请选择您的性别": "Vui lòng chọn giới tính của bạn",
    "你已设置姓名，如需修改，请联系专属客服": "Bạn đã đặt họ tên, nếu cần sửa đổi vui lòng liên hệ CSKH riêng.",
    /* 设置 ===========================================================1 */

    /* 选择语言 ===========================================================0 */
    "选择语言": "Chọn ngôn ngữ",
    "正在切换语言...": "Đang đổi ngôn ngữ...",
    /* 选择语言 ===========================================================1 */

    /* 修改登录密 =========================================================0 */
    "修改登录密码": "Sửa mật khẩu đăng nhập",
    "旧密码": "Mật khẩu cũ",
    "请输入旧密码": "Vui lòng nhập mật khẩu cũ",
    "新密码": "Mật khẩu mới",
    "请输入新密码": "Vui lòng nhập mật khẩu mới",
    "确认密码": "Xác nhận mật khẩu",
    "请确认新密码": "Vui lòng xác nhận mật khẩu mới",
    "修改": "Sửa",
    "修改中...": "Đang sửa...",
    "修改成功，请重新登录": "Sửa thành công, vui lòng đăng nhập lại",
    /* 修改登录密 =========================================================1 */

    /* 设置资金密码 =======================================================1 */
    "设置资金密码": "Cài đặt mật khẩu rút tiền",
    "资金密码必须由四位数字组成": "Mật khẩu rút tiền phải bao gồm 4 chữ số",
    "设置中...": "Đang cài đặt...",
    "设置成功": "Cài đặt thành công",
    /* 设置资金密码 =======================================================1 */
}